export enum Geokoordinatensystem {
    UTM = 'UTM',
    DEZIMALGRAD = 'DEZIMALGRAD',
}

export class GeokoordinatensystemItem {

    public key: string;
    public description: string;

    constructor(key: string, description: string) {
        this.key = key;
        this.description = description;
    }

    public static getAll(): GeokoordinatensystemItem[] {
        return [
            new GeokoordinatensystemItem(Geokoordinatensystem.UTM, 'UTM (ETRS 89)'),
            new GeokoordinatensystemItem(Geokoordinatensystem.DEZIMALGRAD, 'Geokoordinaten Modell (WGS 84)'),
        ];
    }

}
